/*
  Aible Component Library

  Documentation:
  https://docs.google.com/document/d/1lMJrw1umN_lgisxF57urnOOYZGZ3QZJQ3fDAgGy6qCA/edit?usp=sharing
*/

// Utilities
export { default as magnitudeDiff } from "aible/Utils/magnitudeDiff";
export { default as getMagnitude } from "aible/Utils/getMagnitude";
export { default as softRound } from "aible/Utils/softRound";
export { default as getPrettyNumber } from "aible/Utils/getPrettyNumber";
export { default as getRange } from "aible/Utils/getRange";

// Components
export { default as Accordion } from "aible/Accordion/Accordion";
export { default as SenseAccordion } from "aible/SenseAccordion/SenseAccordion";
export { default as Button } from "aible/Button/Button";
export { default as ButtonGroup } from "aible/Button/ButtonGroup";
export { default as Icon } from "aible/Icon/Icon";
export { default as Dropdown } from "aible/Dropdown/Dropdown";
export { default as InfoToolTip } from "aible/InfoToolTip/InfoToolTip";
export { default as NumberLabel } from "aible/NumberLabel/NumberLabel";
// Components/Tiles
export { default as Tile } from "aible/Tile/Tile";
export { default as TileOptionsButton } from "aible/Tile/TileOptionsButton";
export { default as TileTitle } from "aible/Tile/TileTitle";
export { default as TileSubtitle } from "aible/Tile/TileSubtitle";
export { default as TileBody } from "aible/Tile/TileBody";
export { default as TileItem } from "aible/Tile/TileItem";

// Option Enums
import { OPTIONS as softRoundOptions } from "aible/Utils/softRound";

export const OPTIONS = {
  softRound: softRoundOptions
};
